import { Component, Input, OnInit } from "@angular/core"
import { Router } from "@angular/router"
import { AuthService } from "src/app/services/auth.service"
import { HelpersService } from "src/app/services/helpers.service"
import { Subscription } from "rxjs"
import { environment } from "src/environments/environment"

@Component({
	selector: "app-user-dropdown",
	templateUrl: "./user-dropdown.component.html",
	styleUrls: ["./user-dropdown.component.scss"]
})
export class UserDropdownComponent implements OnInit {
	getNewNotifications$: Subscription
	notifications = {}
	@Input() userData: {
		name: string
		surname: string
		email: string
		company: string
		country: string
	}

	constructor(
		public authService: AuthService,
		public helpersService: HelpersService,
		public router: Router
	) {}

	ngOnInit() {
		this.getNewNotifications$ = this.helpersService.notifications.subscribe(res => (this.notifications = res))
	}

	get isOpenFiberUser() {
		if (!environment.production) return true
		return (
			this.userData &&
			this.userData.company &&
			this.userData.company.toLowerCase().replace(/\s/g, "") === "openfiber"
		)
	}

	get isFastwebUser() {
		if (!environment.production) return true
		return (
			this.userData &&
			this.userData.company &&
			(this.userData.company.toLowerCase() === "fastweb" ||
				this.userData.company.toLowerCase().includes("fastweb s.p.a."))
		)
	}
}
